<div class="dashboard-home">
  <div class="welcome-section">
    <h1>Welcome to Complete Pest Dashboard</h1>
    <p>Manage your pest control business efficiently</p>
  </div>

  <div class="quick-actions">
    <mat-card class="action-card" (click)="navigateTo('/dashboard/list/Customer')">
      <mat-card-content>
        <mat-icon>people</mat-icon>
        <h3>Customers</h3>
        <p>Manage customer information</p>
      </mat-card-content>
    </mat-card>

    <mat-card class="action-card" (click)="navigateTo('/dashboard/scheduler')">
      <mat-card-content>
        <mat-icon>schedule</mat-icon>
        <h3>Scheduler</h3>
        <p>Schedule services and appointments</p>
      </mat-card-content>
    </mat-card>

    <mat-card class="action-card" (click)="navigateTo('/dashboard/list/Service')">
      <mat-card-content>
        <mat-icon>build</mat-icon>
        <h3>Services</h3>
        <p>Manage your service offerings</p>
      </mat-card-content>
    </mat-card>

    <mat-card class="action-card" (click)="navigateTo('/dashboard/list/Product')">
      <mat-card-content>
        <mat-icon>inventory</mat-icon>
        <h3>Products</h3>
        <p>Track pest control products</p>
      </mat-card-content>
    </mat-card>
  </div>
</div>